import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetEducationInstitutionsQuery } from '../../../store/apis/dictionaries/education-institution';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetEducationInstitutionsQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Образовательные учреждения')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.educationInstitution}
    />
  );
};

export default List;
